var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJunctions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a9ce;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.1,405.27V269.64a9.61,9.61,0,0,0-9.6-9.6h-100a9.61,9.61,0,0,0-9.6,9.6V405.27H152.65V224.56h294.7V405.27Zm-100-126H402.9v126H322.09ZM300,123.57l156.41,81.2H143.59Zm237,281.7h-70.4V224h29.19a9.6,9.6,0,0,0,4.41-18.12L304.42,104.24a9.58,9.58,0,0,0-8.84,0L99.84,205.85A9.6,9.6,0,0,0,104.26,224h29.19v181.3H63.05a9.6,9.6,0,1,0,0,19.2H246a62.82,62.82,0,0,1-62,53.17h-121a9.6,9.6,0,0,0,0,19.2H184a82.06,82.06,0,0,0,81.36-72.37H537a9.6,9.6,0,0,0,0-19.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.35,342H196.64V279.25h62.71Zm9.6-81.92H187a9.6,9.6,0,0,0-9.6,9.6v81.92a9.6,9.6,0,0,0,9.6,9.6H269a9.6,9.6,0,0,0,9.6-9.6V269.65a9.6,9.6,0,0,0-9.6-9.6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunctions);
export default __webpack_public_path__ + "static/media/junctions.ae2ee495c4daa680beff3fd0888c6df7.svg";
export { ForwardRef as ReactComponent };